import { Flex, Text } from '@chakra-ui/react';
import { useI18nLn } from '~/hooks/store';
import { equalDeliveryInfo } from '~/lib/utils/delivery_info';
import { ShippingSpec } from '~/types/resources';
import { DeliveryBundle } from '~/types/resources/deliveryBundle';
import { DeliveryInfo } from '~/types/resources/deliveryInfo';

type Props = {
  playAmount?: number;
  deliveryBundles: DeliveryBundle[];
  deliveryInfo: DeliveryInfo | null;
  country: ShippingSpec['country'];
  isForceShowRemainDeliveryCount?: boolean; // バンドルの残り入り数がプレイ回数より小さい場合でも残り入り数の表示を強制する
};

export const EventRemainDeliveryCount: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();
  if (props.deliveryBundles.length == undefined) {
    return null;
  }
  const countryDeliveryBundle = props.deliveryBundles.find((deliveryBundle) => {
    return (
      (deliveryBundle.delivery_info.country as ShippingSpec['country']) ==
      props.country
    );
  });
  if (countryDeliveryBundle == null) {
    return null;
  }

  return (
    <>
      {Object.values(props.deliveryBundles).map((deliveryBundle) => {
        if (
          !equalDeliveryInfo(props.deliveryInfo, deliveryBundle.delivery_info)
        ) {
          return null;
        }

        if (
          (props.playAmount ?? 0) > deliveryBundle.available_bundle_amount &&
          !props.isForceShowRemainDeliveryCount
        ) {
          return null;
        }

        return (
          <Flex key={`${deliveryBundle}`} flexDir="column" alignItems="center">
            <Text fontSize="13px" color="red" key={`${deliveryBundle}`}>
              {t('global.common.remain_delivery_count', {
                bundle_amount: countryDeliveryBundle.available_bundle_amount,
              })}
            </Text>
          </Flex>
        );
      })}
    </>
  );
};
